import { pcfraValuesSchema } from '~/common/schemas/pcfra';
import { camdenEmailAddressSchema, contactDetailsFormSchema } from '~/common/schemas/people';
import { tempNumericId } from '~/common/tinybase/utils';
import { PcfraDraftValues } from '~/common/types/pcfra';

import { ContactDetailsFormValues } from '../PersonPage/ContactDetailsEditPage/config';
import { pcfraSections } from './config';
import { PcfraSection, SectionCompletion } from './types';

export const generatePcfraReference = () => String(Math.abs(tempNumericId()));

export const getPrevNextSection = (section?: PcfraSection) => {
  const sectionIndex = section ? pcfraSections.indexOf(section) : -1;
  const prevIndex = sectionIndex - 1;
  const nextIndex = sectionIndex + 1;
  const prevSection = prevIndex >= 0 ? pcfraSections[prevIndex] : undefined;
  const nextSection = nextIndex < pcfraSections.length ? pcfraSections[nextIndex] : undefined;

  return { prevSection, nextSection };
};

export const nextSectionButtonLabel = (
  currentSection?: PcfraSection,
  nextSection?: PcfraSection,
  hasChanges?: boolean,
) => {
  const continueLabel = currentSection && hasChanges ? 'Save and continue' : 'Continue';
  const finishLabel = hasChanges ? 'Save and finish' : 'Finish';
  return nextSection ? continueLabel : finishLabel;
};

export const getSectionCompletion = (values: PcfraDraftValues = {}): SectionCompletion => {
  const { error } = pcfraValuesSchema.safeParse(values);

  const isComplete = (section: PcfraSection) =>
    values[section] && !error?.issues.find(({ path }) => path.includes(section));

  return pcfraSections.reduce(
    (completion, section) => ({
      ...completion,
      [section]: isComplete(section),
    }),
    <SectionCompletion>{},
  );
};

export const hasValidContactDetails = (
  contactDetails: Subset<ContactDetailsFormValues>,
): contactDetails is ContactDetailsFormValues =>
  contactDetailsFormSchema.safeParse(contactDetails).success;

export const hasValidReferrer = (referrerEmail: string) =>
  camdenEmailAddressSchema.safeParse(referrerEmail).success;
